import { createSelector, createSlice } from '@reduxjs/toolkit';
import { PdpState } from '../store';

export const { actions, reducer } = createSlice({
    name: 'tenant',
    initialState: {
        id: 'missing'
    },
    reducers: {}
});

export const selectTenantId = createSelector(
    (state: PdpState) => state.tenant.id,
    id => id);